import React from "react";
import HighD from "./result/HighD";
import HighS from "./result/HighS";
import HighI from "./result/HighI";
import HighC from "./result/HighC";
import CIS from "./result/CIS";
import IS from "./result/IS";
import DI from "./result/DI";
import SI from "./result/SI";
import SCD from "./result/SCD";

const ResultWrapper = ({ result }) => {
  if (result?.result?.result?.name === "Result-oriented(نتیجه گرا) DI") {
    return <DI testResult={result} />;
  }

  if (result?.result?.result?.name === "Counselor(مشاور) IS") {
    return <IS testResult={result} />;
  }

  if (result?.result?.result?.name === "Pratitioner(تمرین کننده)CIS") {
    return <CIS testResult={result} />;
  }

  if (
    result?.result?.result?.name === "Objective thinker(متفکر هدفمند) High C"
  ) {
    return <HighC testResult={result} />;
  }

  if (result?.result?.result?.name === "Promoter (ترویج دهنده) High I") {
    return <HighI testResult={result} />;
  }

  if (result?.result?.result?.name === "Specialist(متخصص) High S") {
    return <HighS testResult={result} />;
  }

  if (result?.result?.result?.name === "Developer(توسع دهنده) High D") {
    return <HighD testResult={result} />;
  }

  if (result?.result?.result?.name === "Agent(نماینده) SI") {
    return <SI testResult={result} />;
  }
};

export default ResultWrapper;
